// extracted by mini-css-extract-plugin
export default {"wrapper":"login_wrapper__lflf2","redirectLogin":"login_redirectLogin__PpPgS"};